import { type Quote } from '../../../../modules/quotes'
import { type QuotesViewHandler } from '../quotesView.types'

const sort = (quotes: Quote[]) => {
  return quotes.sort((a, b) => {
    const aPrice = a.subtotal.price
    const bPrice = b.subtotal.price
    if (aPrice < bPrice) {
      return -1
    }
    if (aPrice > bPrice) {
      return 1
    }
    return 0
  })
}

const viewHandler: QuotesViewHandler = {
  sort,
}

export default viewHandler
